import { ActionIcon, Badge, Button, Divider, Grid, Group, Menu, Paper, Text, UnstyledButton, useMantineTheme } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import moment from 'moment';
import React, { useEffect } from 'react';
import { FaAngleDoubleDown, FaAngleDoubleUp, FaAngleDown, FaAngleUp, FaBars, FaBookmark, FaRegArrowAltCircleRight, FaInfoCircle, FaMinus, FaRegBookmark, FaBullseye, FaCheck, FaSquare, FaSquarespace, FaSquareFull } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useApp } from '../contexts/app.context';
import { useAuth } from '../contexts/auth.context';
import { FOLLOW_THEME, INTERACT_THEME } from '../services/themes';

export default function ThemePaper({ theme : th }){
    const theme = useMantineTheme();
    const { userData } = useAuth();
    
    const [followTemp, setFollowTemp] = React.useState<any>(undefined);
    const [favorableTemp, setFavorableTemp] = React.useState<any>(undefined);
    const [priorityTemp, setPriorityTemp] = React.useState<any>(undefined);
    const [tags, setTags] = React.useState<string[]>([]);

    const { role } = useAuth();
    const { openTheme } = useApp();

    const follow = () => {
        const isF = isFollowing();
        setFollowTemp(!isF);
        
        FOLLOW_THEME(th.id, !isF)
        .then(res => {})
        .catch(err => {
            setFollowTemp(isF);
            showNotification({ title: "Ops", message: err.message })
        })
    }
    
    const interact = ({favorable, priority, tags} : {favorable?: string, priority?: string, tags?: string[]}) => {
        if(tags) setTags(tags);
        const isF = getFavorable();
        const isP = getPriority();

        let params : any = {
            tags: tags ?? [],
        };
        if(tags){ params.tags = tags; }
        if(favorable !== undefined){
            params.favorable = favorable;
            setFavorableTemp(favorable);
        }
        if(priority !== undefined){
            params.priority = priority;
            setPriorityTemp(priority);
        }
        
        INTERACT_THEME(th.id, params)
        .then(res => {})
        .catch(err => {
            setFavorableTemp(isF);
            setPriorityTemp(isP);
            showNotification({ title: "Ops", message: err.message })
        })
    }
    
    const isFollowing = () => followTemp !== undefined ? followTemp : !!th.follow;
    const getFavorable = () => favorableTemp !== undefined ? favorableTemp : th.favorable;
    const getPriority = () => priorityTemp !== undefined ? priorityTemp : th.priority;
    
    useEffect(() => {
        setTags(th.tags ?? []);
    }, [th])

    return <Paper shadow="sm" p="lg" m="md">
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <div style={{flex: 1}}>
                <Text weight="bold">{th.title}</Text>
                <Text weight="bold">{th.follow}</Text>
            </div>
            <BadgeOrigin origin={th.origin} />
            {th.originUrl && <UnstyledButton ml="xs" onClick={() => window.open(th.originUrl, "_blank")}><FaRegArrowAltCircleRight color="gray" /></UnstyledButton>}
        </div>
        <div style={{padding: '20px 0'}}>
            <Text>{th.description}</Text>
        </div>

        <Group align='flex-start' pb="xs">
            <Group pb="md" style={{flex: 1}} align='flex-start'>
                {tags.map(tag => <Badge>{tag}</Badge>)}
            </Group>

            <Menu closeOnItemClick={false}>
                <Menu.Target><ActionIcon><FaBullseye /></ActionIcon></Menu.Target>
                <Menu.Dropdown>
                    {(userData?.company?.tags ?? []).map(tag => (
                        <Menu.Item icon={tags.includes(tag) ? <FaCheck /> : <FaSquare color="#EFEFEF" />} onClick={() => { interact({
                            tags: tags.includes(tag)
                                ? tags.filter(t => t !== tag)
                                : [...tags,tag]
                        }) }}>{tag}</Menu.Item>
                    ))}
                </Menu.Dropdown>
            </Menu>
        </Group>

        {(th.keywords || []).length > 0 && <Group pb="md" position="right">
            {th.keywords.map(k => <Badge size="xs" color="gray">{k}</Badge>)}
        </Group>}
        
        <Divider />
        <div style={{padding: '10px 0', display: 'flex', flexDirection: 'row'}}>
            <div style={{flex: 1, paddingRight: 10}}>
                <Text size="sm" color={theme.colors.gray[6]}>Situação: {th.status?.title}{th.status?.description && ` - ${th.status?.description}`}</Text>
            </div>
            <Text size="xs" color={theme.colors.gray[6]}>{moment(th.status?.created_at).format("DD/MM/YYYY HH:mm")}</Text>
        </div>
        <Divider />
        
        {th.tramitations.map(tramitation => <>
            <Divider />
            <div style={{padding: '10px 0', display: 'flex', flexDirection: 'row'}}>
                <div style={{flex: 1, paddingRight: 10}}>
                    <Text size="sm" color={theme.colors.gray[6]}>Tramitação: {tramitation.title}</Text>
                </div>
                <Text size="xs" color={theme.colors.gray[6]}>{moment(tramitation.created_at).format("DD/MM/YYYY HH:mm")}</Text>
            </div>
        </>)}
        <Divider />
        <div style={{padding: '10px 0', display: 'flex', flexDirection: 'row'}}>
            <div style={{flex: 1, paddingRight: 10}}>
                <Text size="sm" color={theme.colors.gray[6]}>Apresentação: {(th.authors || []).map(author => author.name).join(", ")}</Text>
            </div>
            <Text size="xs" color={theme.colors.gray[6]}>{moment(th.created_at).format("DD/MM/YYYY HH:mm")}</Text>
        </div>
        <Divider />
        
        {th.events.map(event => <>
            <Divider />
            <div style={{padding: '10px 0', display: 'flex', flexDirection: 'row'}}>
                <div style={{flex: 1, paddingRight: 10}}>
                    <Text size="sm" color={theme.colors.gray[6]}>Agenda: {event.title}</Text>
                </div>
                <Text size="xs" color={theme.colors.gray[6]}>{moment(event.start).format("DD/MM/YYYY HH:mm")}</Text>
            </div>
        </>)}
        <Divider />

        <Grid style={{padding: '10px 0', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
            <Grid.Col sm={6} md={6}>
                <Button
                    onClick={() => openTheme(th)}
                    // component={Link}
                    // to={`/pauta/${th.id}`}
                    variant="subtle"
                    leftIcon={<FaInfoCircle/>}
                    fullWidth
                >Mais detalhes</Button>
            </Grid.Col>
            {role && <Grid.Col sm={6} md={6}>
                <Button
                    onClick={() => follow()}
                    variant={!isFollowing() ? "subtle" : "filled"}
                    leftIcon={!isFollowing() ? <FaRegBookmark /> : <FaBookmark/>}
                    fullWidth
                >{!isFollowing() ? 'Acompanhar' : 'Deixar de Acompanhar'}</Button>
            </Grid.Col>}
            {role && <Grid.Col sm={6} md={6}>
                <Menu>
                    <Menu.Target>
                        <Button
                                fullWidth
                                variant={getFavorable() ? "outline" : "subtle"}
                                color={['unfavorable', 'unfavorable-res'].includes(getFavorable())
                                    ? 'red'
                                    : ['favorable', 'favorable-res'].includes(getFavorable())
                                        ? 'green'
                                        : getFavorable() === 'neutral'
                                            ? 'gray'
                                            : null}
                                leftIcon={<FaBars />}
                            >Posicionamento</Button>
                    </Menu.Target>
                    <Menu.Dropdown>
                        {[
                            {key: 'favorable', color: 'green', title: "Favorável", icon: <FaAngleDoubleUp />},
                            {key: 'favorable-res', color: 'green', title: "Favorável - com ressalvas", icon: <FaAngleUp />},
                            {key: 'neutral', color: 'gray', title: "Neutro", icon: <FaMinus />},
                            {key: 'unfavorable-res', color: 'red', title: "Contra - com ressalvas", icon: <FaAngleDown />},
                            {key: 'unfavorable', color: 'red', title: "Contra", icon: <FaAngleDoubleDown />},
                        ].map(item => (
                            <Button
                                onClick={() => interact({
                                    favorable: getFavorable() === item.key
                                    ? null : item.key})}
                                variant={getFavorable() === item.key ? "filled" : "subtle"}
                                color={item.color}
                                leftIcon={item.icon}
                                styles={{
                                    inner: {justifyContent: 'flex-start', textAlign: 'left', fontSize: 12},
                                    icon: {padding: 0},
                                    root: {marginBottom: 5}
                                }}
                                fullWidth
                            >{item.title}</Button>
                        ))}
                    </Menu.Dropdown>
                </Menu>
            </Grid.Col>}
            {role && <Grid.Col sm={6} md={6}>
                <Menu>
                    <Menu.Target>
                        <Button
                            fullWidth
                            variant={getPriority() ? "outline" : "subtle"}
                            color={{
                                'very-high': 'green',
                                'high': 'teal',
                                'medium': 'gray',
                                'low': 'yellow',
                                'very-low': 'red',
                            }[getPriority()] || null}
                            leftIcon={<FaBars />}
                        >{{
                            'very-high': "Prioridade - Muito alta",
                            'high': "Prioridade - Alta",
                            'medium': "Prioridade - Média",
                            'low': "Prioridade - Baixa",
                            'very-low': "Prioridade - Muito baixa",
                        }[getPriority()] || "Prioridade"}</Button>
                    </Menu.Target>
                    <Menu.Dropdown>
                        {[
                            {key: 'very-high', color: 'green', title: "Muito alta", icon: <FaAngleDoubleUp />},
                            {key: 'high', color: 'teal', title: "Alta", icon: <FaAngleUp />},
                            {key: 'medium', color: 'gray', title: "Média", icon: <FaMinus />},
                            {key: 'low', color: 'yellow', title: "Baixa", icon: <FaAngleDown />},
                            {key: 'very-low', color: 'red', title: "Muito baixa", icon: <FaAngleDoubleDown />},
                        ].map(item => (
                            <Button
                                onClick={() => interact({
                                    priority: getPriority() === item.key
                                    ? null : item.key})}
                                variant={getPriority() === item.key ? "filled" : "subtle"}
                                color={item.color}
                                leftIcon={item.icon}
                                styles={{
                                    inner: {justifyContent: 'flex-start', textAlign: 'left', fontSize: 12},
                                    icon: {padding: 0},
                                    root: {marginBottom: 5}
                                }}
                                fullWidth
                            >{item.title}</Button>
                        ))}
                    </Menu.Dropdown>
                </Menu>
            </Grid.Col>}
        </Grid>
    </Paper>
}


export const BadgeOrigin = ({origin} : {origin : "camara" | "senado"}) => {
    const {background, text} = {
        camara: {background: 'green', text: "Câmara dos Deputados"},
        senado: {background: 'blue', text: "Senado Federal"},
    }[origin];
    return <Badge color={background}>{text}</Badge>
}